<div class="business-list-view col-md-12 padding-right-0 padding-left-0">
  <div class="hpanel">
    <div class="d-flex align-items-center justify-content-between panel-body border-radius-top-left-right-6">
      <label
        class="padding-right-10 font-size-bold"
        title="{{values.communityName}}"
      >
        {{ values.communityName | truncate: 20 }}
      </label>
      <div class="d-flex align-items-center">
        <div class="form-group mr-2">
          <div class="input-group">
            <input
              type="text"
              style="margin-top:14px;"
              class="form-control"
              placeholder="Search Request Received"
              [(ngModel)]="searchKey"
              (click)="onsearch(name)"
              [ngModelOptions]="{ standalone: true }"
              aria-label="Amount (to the nearest dollar)"
            />
          </div>
        </div>
        <div class="btn-group mr-2" dropdown container="body">
          <button
            id="button-container"
            [disabled]="true"
            class="btn primary-btn"
            aria-controls="dropdown-container"
          >
            <ng-icon name="tablerFilter"></ng-icon>
          </button>
          <ul
            id="dropdown-container"
            *dropdownMenu
            class="dropdown-menu"
            role="menu"
            aria-labelledby="button-container"
          >
          </ul>
        </div>
        <button
          class="btn primary-btn"
          style="min-width: 50px !important;"
          disabled
        >
          Advance Search
        </button>
      </div>
    </div>
  </div>

  <div>
    <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 paddin-bottom-5"
      *ngFor="let data of values.request | filter:searchKey">
      <div class="hpanel  contact-panel">
        <div class="panel-body  h-153" (click)="userprofile(data.userId)" style="cursor: pointer;">
          <div class="sdhsujpf ">
            <!-- <button type="button" class=" tesssss btn btn-default margin-left-13  btn-xs dropdown-toggle"
              (click)="updateRequest(data,'REJECT');$event.stopPropagation();"> Reject </button>

              &nbsp;&nbsp;&nbsp;
            <button type="button" class="btn btn-primary radius-0 btn-xs dropdown-toggle"
              (click)="updateRequest(data,'ACCEPT');$event.stopPropagation();"> Accept
            </button> -->


            <button type="button" class="btn btn-primary b-5  btn-xs"
              (click)="updateRequest(data,'ACCEPT');$event.stopPropagation();">Accept</button>

            <div class="btn-group three_icon_cmon1 hovers" id="the-dropdown" dropdown
              (click)="$event.stopPropagation();">
              <!-- *ngIf="post.postEntityId==userId" -->
              <a id="button-animated" dropdownToggle class="m-r-10">
                <!-- <ng-icon name="tablerDots"></ng-icon> -->
                <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote h3m">
              </a>
              <ul id="dropdown-animated" id="the-dropdowns" *dropdownMenu class="dropdown-menu m-l-81 left-auto-0"
                role="menu" aria-labelledby="button-animated">
                <li role="menuitem" dropdown>
                  <a class="dropdown-item common-font-12 padd" dropdownToggle
                    (click)="updateRequest(data,'REJECT');$event.stopPropagation();">Reject</a>
                </li>
              </ul>
            </div>





          </div>


          <img alt="logo" class="img-circle  " (click)="userprofile(data.userId)" src={{data.photo}}>

          <div class="ellipse" style="font-size:20px; margin-top: 10px;" data-toggle="tooltip" data-placement="top"
            title="{{data.userName}}" (click)="userprofile(data.userId)">{{data.userName|truncate:15}} </div>

          <div class="text-muted font-bold m-b-xs " data-toggle="tooltip" data-placement="top" title="{{data.title}}">
            {{data.title|truncate:15}}</div>
          <p data-toggle="tooltip" data-placement="top" title="{{data.organisation}}">
            {{data.organisation |truncate:15}}
          </p>
        </div>

      </div>
      <div class="iiiei">
        <div class="s1s">
          <div class="eerr"> CONNECTIONS</div>
          <div class="sfkp">{{data.connectionCnt}}</div>
        </div>
        <div class="s2s">
          <div class="eerr1">POSTS</div>
          <div class="lgho">{{data.postCnt}}</div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pad" *ngIf="values?.request?.length==0 && showNoDatafound">
      <app-nodata-found [title]="noDatafound"></app-nodata-found>
    </div>

  </div>
</div>
